import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2 } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ArticleDetail = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/articles/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div>
      <Header />
      <div className="max-w-3xl mx-auto px-5 py-10" data-testid="article-detail">
        <Link to="/" className="inline-flex items-center gap-2 text-[#9E2A3B] font-medium hover:underline mb-6">
          <ArrowLeft className="w-4 h-4" /> Ana Sayfa
        </Link>

        {loading ? (
          <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#C15B6B]" /></div>
        ) : notFound || !article ? (
          <div className="py-20 text-center">
            <h1 className="font-display text-2xl font-bold text-[#2A2224]">Yazı bulunamadı</h1>
            <p className="text-[#7C6E70] mt-2">Aradığınız rehber yazı yayından kaldırılmış olabilir.</p>
          </div>
        ) : (
          <article>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-[#2A2224] leading-tight">{article.title}</h1>
            {article.excerpt && <p className="text-lg text-[#7C6E70] mt-3">{article.excerpt}</p>}
            {article.image && (
              <img src={article.image} alt={article.title} className="w-full rounded-2xl mt-6 border border-[#F0DDE0]" />
            )}
            {article.content ? (
              <div className="mt-7 text-[#3d3335] leading-relaxed whitespace-pre-wrap text-[15px]">{article.content}</div>
            ) : (
              <p className="mt-7 text-[#7C6E70]">Bu yazının içeriği yakında eklenecek.</p>
            )}
          </article>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ArticleDetail;
